import { yupResolver } from '@hookform/resolvers/yup';
import { Button, Form, Modal } from 'antd';
import React, { useContext, useState } from 'react';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
// import productFormatFile from '../../../assets/files/productFormat.xlsx';
import { CloudDownloadOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import importExcelApi from '../../apis/store-apis/products/importExcelApi';
import clinte from '../../assets/files/clinte.xlsx';
import FileInput from '../../common/file-input/FileInput';
import LoadingModal from '../../common/loading-modal/LoadingModal';
import ClientsContext from '../../contexts/clients-context/ClientsContext';
import UserContext from '../../contexts/user-context/UserProvider';
import useCustomApiRequest from '../../custom-hooks/useCustomApiRequest';
import errorNotification from '../../utils/errorNotification';
import successNotification from '../../utils/successNotification';

const ExcelModal = () => {
  const { user } = useContext(UserContext);
  const { t } = useTranslation();

  const schema = Yup.object().shape({
    file: Yup.mixed().required(t('Clients.PleaseSelectClientFile')),
    type: Yup.string().required(t('Clients.Pleaseselectaclienttype'))
  });

  const { setFetchCount, excelModalOpened, setExcelModalOpened } =
    useContext(ClientsContext);

  const {
    handleSubmit,
    setValue,
    watch,
    register,
    unregister,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema),
    mode: 'all',
    defaultValues: {
      file: null,
      type: '1'
    }
  });
  const [isSubmittingForm, setIsSubmittingForm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const customApiRequest = useCustomApiRequest();
  const onSubmit = (data) => {
    const formData = new FormData();

    if (data?.type) formData.append('type', data.type);
    if (data.file?.length > 0) formData.append('file', data.file[0]);
    setIsLoading(true);
    setIsSubmittingForm(true);
    customApiRequest(
      importExcelApi(user?.token, formData, '/Excel/importClient'),
      (res) => {
        setIsLoading(false);
        setIsSubmittingForm(false);
        if (res?.data?.status === 1) {
          setExcelModalOpened(false);
          setFetchCount((prevState) => prevState + 1);
          successNotification({
            title: t('Messages.addedSuccessfully'),
            message: t('Messages.addsuccessfully')
          });
        } else {
          errorNotification({
            title: t('Messages.ErrorOccurred'),
            message: res?.data?.message
              ? res.data.message
              : t('Messages.TryAgainLater')
          });
        }
      },
      (error) => {
        setIsSubmittingForm(false);
        setIsLoading(false);
        errorNotification({
          title: t('Messages.ErrorOccurred'),
          message: error?.response?.data?.message || t('Messages.TryAgainLater')
        });
      }
    );
  };

  const [form] = Form.useForm();
  return (
    <Modal
      transitionName=""
      className="shared-custom-modal"
      width="90%"
      style={{ maxWidth: '542px' }}
      title={t('Clients.UploadClientData')}
      visible={excelModalOpened}
      onOk={() => {
        setExcelModalOpened(false);
      }}
      onCancel={() => {
        setExcelModalOpened(false);
      }}
      footer={false}
    >
      <div className="excel-download-btns-wrap">
        <a className="excel-download-btn" href={clinte}>
          <CloudDownloadOutlined />
          <span className="label-span">
            {t('Clients.downloadsupplierProfile')}
          </span>
        </a>

        {/* <a className="excel-download-btn" href={productMaterialFormatFile}>
          <CloudDownloadOutlined />
          <span className="label-span">تحميل ملف منتج بالمكونات التعريفى </span>
        </a> */}
      </div>

      <Form
        className="store-new-product-form custom-shared-form"
        form={form}
        layout="vertical"
        onFinish={handleSubmit(onSubmit)}
      >
        <div className="form-body" style={{ marginTop: 22 }}>
          {/* <AntdRadioGroup
            name="type"
            className="form-radio-group"
            control={control}
            label="اختار نوع السلعة"
            validateStatus={errors?.type ? 'error' : ''}
            errorMsg={errors?.type?.message}
            onChange={() => setValue('model_id', '')}
            radios={[
              {
                title: 'منتجات',
                value: '1'
              },
              {
                title: 'مكونات منتجات',
                value: '2'
              }
            ]}
            isRadioButton
          /> */}
          <FileInput
            name="file"
            // label="ارفع ملف الاسئلة المطلوبة"
            label={null}
            // accept="image/png, image/jpg, image/jpeg, image/gif, .pdf"
            accept=".xlsx"
            multiple={false}
            setValue={setValue}
            watch={watch}
            register={register}
            unregister={unregister}
            // setUrls={setUrls}
            dropzoneText={t('Clients.clickForDownload')}
            className="product-images-dropzone"
            //  dropzoneUrls={
            //    selectedCategory?.image ? [{ url: selectedCategory.image }] : []
            //  }
            canDelete={false}
          />
          {errors?.file && (
            <p className="error-p">
              {errors?.file?.message && errors.file.message}
            </p>
          )}
          <Button
            className="submit-btn"
            htmlType="submit"
            type="primary"
            // icon={<LoginOutlined />}
            loading={isSubmittingForm}
          >
            {t('Clients.upload')}
          </Button>
        </div>
      </Form>

      {isLoading && <LoadingModal />}
    </Modal>
  );
};

export default ExcelModal;
